export var OAuthProvider;
(function (OAuthProvider) {
    OAuthProvider["GOOGLE"] = "google";
    OAuthProvider["MICROSOFT"] = "microsoft";
    OAuthProvider["MONDAY"] = "monday";
    OAuthProvider["LINKEDIN"] = "linkedin";
    OAuthProvider["LINKEDIN_ORG"] = "linkedin_org";
    OAuthProvider["FACEBOOK"] = "facebook";
    OAuthProvider["INSTAGRAM"] = "instagram";
    OAuthProvider["TIKTOK"] = "tiktok";
    OAuthProvider["TWITTER"] = "twitter";
    OAuthProvider["YOUTUBE"] = "youtube";
    OAuthProvider["PINTEREST"] = "pinterest";
    OAuthProvider["GITHUB"] = "github";
})(OAuthProvider || (OAuthProvider = {}));
export const OAUTH_PROVIDER_METADATA = {
    [OAuthProvider.GOOGLE]: {
        provider: OAuthProvider.GOOGLE,
        displayName: 'Google',
        logoUrl: 'https://dapulse-res.cloudinary.com/image/upload/v1766063757/taka/providers-logos/google.svg',
    },
    [OAuthProvider.MICROSOFT]: {
        provider: OAuthProvider.MICROSOFT,
        displayName: 'Microsoft',
        logoUrl: 'https://dapulse-res.cloudinary.com/image/upload/v1766492383/taka/providers-logos/ms_outlook.svg',
    },
    [OAuthProvider.MONDAY]: {
        provider: OAuthProvider.MONDAY,
        displayName: 'monday.com',
        logoUrl: 'https://dapulse-res.cloudinary.com/image/upload/v1766063757/taka/providers-logos/monday.svg',
    },
    [OAuthProvider.LINKEDIN]: {
        provider: OAuthProvider.LINKEDIN,
        displayName: 'LinkedIn',
        logoUrl: 'https://dapulse-res.cloudinary.com/image/upload/v1766063757/taka/providers-logos/Linkdin.svg',
    },
    [OAuthProvider.LINKEDIN_ORG]: {
        provider: OAuthProvider.LINKEDIN_ORG,
        displayName: 'LinkedIn Company Page',
        logoUrl: 'https://dapulse-res.cloudinary.com/image/upload/v1766063757/taka/providers-logos/Linkdin.svg',
    },
    [OAuthProvider.FACEBOOK]: {
        provider: OAuthProvider.FACEBOOK,
        displayName: 'Facebook',
        logoUrl: 'https://dapulse-res.cloudinary.com/image/upload/v1766063757/taka/providers-logos/Facebook.svg',
    },
    [OAuthProvider.INSTAGRAM]: {
        provider: OAuthProvider.INSTAGRAM,
        displayName: 'Instagram',
        logoUrl: 'https://dapulse-res.cloudinary.com/image/upload/v1766063757/taka/providers-logos/Instagram.svg',
    },
    [OAuthProvider.TIKTOK]: {
        provider: OAuthProvider.TIKTOK,
        displayName: 'TikTok',
        logoUrl: 'https://sf-tb-sg.ibytedtos.com/obj/eden-sg/uhtyvueh7nulogpoguhm/tiktok-icon2.png',
    },
    [OAuthProvider.YOUTUBE]: {
        provider: OAuthProvider.YOUTUBE,
        displayName: 'YouTube',
        logoUrl: 'https://ik.imagekit.io/8ybt5kraw/providers-logos/youtube.svg',
    },
    [OAuthProvider.PINTEREST]: {
        provider: OAuthProvider.PINTEREST,
        displayName: 'Pinterest',
        logoUrl: 'https://ik.imagekit.io/8ybt5kraw/tr:orig-true/providers-logos/pinterest.svg',
    },
    [OAuthProvider.GITHUB]: {
        provider: OAuthProvider.GITHUB,
        displayName: 'GitHub',
        logoUrl: 'https://dapulse-res.cloudinary.com/image/upload/v1766492383/taka/providers-logos/github.svg',
        comingSoon: true,
    },
    [OAuthProvider.TWITTER]: {
        provider: OAuthProvider.TWITTER,
        displayName: 'X',
        logoUrl: 'https://dapulse-res.cloudinary.com/image/upload/v1766063757/taka/providers-logos/Twitter.svg',
    },
};
export function getOAuthProviderMetadata(provider) {
    const normalizedProvider = provider.toLowerCase();
    return OAUTH_PROVIDER_METADATA[normalizedProvider];
}
export function getOAuthProviderLogoUrl(provider) {
    return getOAuthProviderMetadata(provider)?.logoUrl;
}
export function getOAuthProviderDisplayName(provider) {
    return getOAuthProviderMetadata(provider)?.displayName ?? provider;
}
export function isOAuthProviderComingSoon(provider) {
    return getOAuthProviderMetadata(provider)?.comingSoon ?? false;
}
export function getAllOAuthProviders() {
    return Object.values(OAuthProvider);
}
const SOCIAL_OAUTH_PROVIDERS = new Set([
    OAuthProvider.INSTAGRAM,
    OAuthProvider.FACEBOOK,
    OAuthProvider.LINKEDIN,
    OAuthProvider.LINKEDIN_ORG,
    OAuthProvider.TIKTOK,
    OAuthProvider.YOUTUBE,
    OAuthProvider.PINTEREST,
    OAuthProvider.TWITTER,
]);
export function isSocialOAuthProvider(provider) {
    return SOCIAL_OAUTH_PROVIDERS.has(provider.toLowerCase());
}
export function getAllOAuthProviderMetadata() {
    return Object.values(OAUTH_PROVIDER_METADATA);
}
//# sourceMappingURL=oauth-provider.const.js.map